import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './resources';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    supportedLngs: ['ja', 'en', 'fr', 'de', 'es', 'ko'],
    
    resources: Object.keys(resources).reduce((acc, lang) => {
      acc[lang] = { translation: (resources as any)[lang] };
      return acc;
    }, {} as any),
  });

export default i18n;